import styled from 'styled-components';

export const PageContainer = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  font-family: "AvenirNextLTW01-Regular";
  padding-bottom: 30px;
  width: 100%;
  background-image: ${(props) => `url(${props.backgroundImage})`};
  // padding-left: 15px;
  // padding-right: 15px;
`;

export const SuccessContainer = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  width: 600px;
  justify-content: center;
  margin-top: ${(props) => (props.isMobile ? '0px;' : '80px;')}
`;

export const GoalcardContainer = styled.div`
  width: 50%;
  min-width: 280px;
  // height: 230px;
  // max-height: 230px;
  border-radius: 6px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  background-color: #fff;
  padding: 10px;
`;

export const Button = styled.a`
  display: inline-block;
  min-width: 140px;
  height: 45px;
  // margin: 0 10px 45px;
  line-height: 45px;
  background-color: #F3A802;
  outline: none;
  border: 0;
  border-radius: 5px;
  color: #fff;
  text-transform: uppercase;
  font-size: .9em;
  text-align: center;
  opacity: 1;
  padding-left: 50px;
  padding-right: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'Avenir Next LT W01 Demi';
  transition: all .35s;
  &:hover {
    background-color: #f39502;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 15px;
  }
`;
export const Description = styled.label`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  font-family: "AvenirNextLTW01-Regular";
  color: #fff;
`;

export const GoalcardImage = styled.img`
  min-height: 200px;
  max-width: 100%;
  text-align: center;
`;

export const InfoContainer = styled.div`
  display:flex;
  flex-direction: column;
  width: 80%;
  align-items: center;
  margin-bottom: 30px;
  text-align: center;
  margin-top: ${(props) => (props.isMobile ? '30px;' : '0px;')}
`;

export const Title = styled.label`
  font-size: 26px;
  font-weight: 300;
  line-height: 1.3;
  font-family: "AvenirNextLTW01-Regular";
  color: #fff;
  // margin-bottom: 20px;
`;

export const TitleBold = styled.label`
  font-size: 26px;
  font-weight: 900;
  line-height: 1.3;
  font-family: "AvenirNextLTW01-Regular";
  color: #fff;
  // margin-bottom: 20px;
`;

export const TitleContainer = styled.div`
  display:flex;
  flex-direction: column;
  width: 70%;
  margin-top:30px;
  // align-items: center;
  // margin: 30px 0px 10px 0;
  // text-align: center;
`;

export const SupportLabelContainer = styled.div`
  display:flex;
  flex-direction: row;
  background-color: #3b2f71;
  width: 100%;
  justify-content: center;
`;

export const SupportLabel = styled.label`
  font-size: 11px;
  margin: 7px 0;
  line-height: 1.75;
  font-weight: 400;
  color: #fff;
  text-align: center;
`;

export const SupportEmail = styled.a`
  color: #F3A802;
  border-bottom: 1px solid;
  text-decoration: none;
`;
